export function validateEmail(value: string): boolean {
  return /^[^\s@]{2,}@([^\s@.]{2,}\.)+[^\s@.]{2,}$/.test(value)
}

export function validatePhone(value: string): boolean {
  return /^(8|\+7)\d{10,}$/.test(value)
}
